export default __webpack_public_path__ + "static/media/saint-malo8.f9027022.jpg";